<template>
	<div class="customSwim">
		<section class="ticketTop">
			<back-to :url="customSwim" :title="type=='DzyFl'?'东北定制游':'周边游'"></back-to>
			<div class="search">
				<img src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/sweetour-h5_retailstore_search.png"
					alt="">
				<!-- <span class="placeholder">输入目的地、景点或关键词</span> -->
				<input type="text" class="packageSearch_con__input" placeholder="请输入关键字" @input="onSearch" />
			</div>
			<div class="cityList">
				<div class="city_left">
					<span v-if="unfold?index >=0:index < 4" :class="dbIndex == item.key?'city_active':''"
						v-for="(item, index) in dbRegion" :key="index"
						@click="dbIndex=item.key,page=1,customSwim_list=[],connectGroup(true)">{{item.name}}</span>
				</div>
				<div v-if="dbRegion.length > 4" class="city_right" @click="unfold = !unfold">
					<p type="" :class="unfold?'arrow-down':'arrow-up'" />
				</div>
			</div>
		</section>
		<section class="customSwim_tablist">
			<div class="tablist">
				<label for="" :class="[item.theme == dbTheme?'activeTab':'']"
					@click="dbTheme=item.theme,page=1,customSwim_list=[],connectGroup(true)"
					v-for="(item, index) in tabList" :key="index">{{item.title}}</label>
			</div>
		</section>
		<van-list class="customSwim_list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
			:immediate-check="false">
			<div class="customSwim_list-item" v-for="(item, index) in data_product_array" :key="index"
				@click="item.refPrice != 0?$router.push({path: '/swimDetail',query: {id: item.id}}):''">
				<span class="customSwim_list-iteml">
					<img class="card-item-inner_img" v-lazy="item.picturePath" />
					<label for="">
						<p>
							<font>{{type=='DzyFl'?'定制游':'周边游'}}</font>
						</p>
					</label>
				</span>
				<span class="customSwim_list-itemr">
					<h2>{{item.title}}</h2>
					<label for="" class="customSwim_list-itemr-tag">
						<p v-for="(val,key) in item.tags" :key="key">{{val}}</p>
					</label>
					<label for="" v-if="item.refPrice != 0" class="customSwim_list-itemr-price">
						<b>￥</b>
						<font>{{item.refPrice}}</font>
						<p>起</p>
					</label>
					<label for="" v-else class="customSwim_list-itemr-prices">敬请期待</label>
				</span>
			</div>
		</van-list>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'customSwim',
		components: {
			BackTo
		},
		data() {
			return {
				customSwim: '/',
				random: 0,
				loading: false,
				finished: false,
				page: 1,
				data_product_array: [],
				dbRegion: [],
				dbIndex: "",
				tabList: [],
				dbTheme: "",
				unfold: false,
				title: "",
				type: 'DzyFl'
			}
		},
		created() {
			this.random = Math.random()
			// this.dbTheme = this.$route.query.dbTheme ? this.$route.query.dbTheme : '44'
			this.type = this.$route.query.type ? this.$route.query.type : 'DzyFl'
			this.getDbCity()
		},
		methods: {
			async getDbCity() {
				try {
					if (this.type == 'DzyFl') {
						const [userResponse, postResponse] = await Promise.all([
							this.$_post(this.$connectHttpDayun + '/erpteam/teampro/api/getapt', {
								type: this.type
							}),
							this.$get(this.$login + '/api/GetAppMenuList', {})
						])
						this.dbRegion = userResponse
						this.dbIndex = userResponse[0].key
						var tabList = postResponse.data.find(item => item.areaNo === 5).items[0].items
						tabList.forEach(function(item) {
							item.theme = JSON.parse(item.param).theme
						})
						this.tabList = tabList
						this.dbTheme = tabList[0].theme
					} else {
						const [userResponse] = await Promise.all([
							this.$_post(this.$connectHttpDayun + '/erpteam/teampro/api/getapt', {
								type: this.$route.query.type
							})
						])
						this.dbRegion = userResponse
						this.dbIndex = userResponse[0].key
						this.dbTheme = '44'
					}
					this.connectGroup()
				} catch (err) {
					this.error = err.message
				}
			},
			onSearch(e) {
				this.title = e.data
				this.page = 1
				this.data_product_array = []
				this.connectGroup()
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.connectGroup()
				}, 500);
			},
			connectGroup(e) {
				// if (this.jqId > 0) {
				// 	var object = {
				// 		'platformid': "3",
				// 		'is_sny': 1,
				// 		'pods': [{
				// 			'podId': this.jqId
				// 		}]
				// 	}
				// } else {

				// }
				var object = {
					'theme': this.dbTheme,
					'platformid': this.$platformid,
					'is_sny': 1,
					'zoneString': this.dbIndex,
					'title': this.title
				}
				var data = {
					"pageIndex": this.page,
					"pageSize": 10,
					"object": object
				}
				this.$_post(
					this.$connectHttpDayun + '/team/mobile/indirect/pagefxwd', data
				).then(res => {
					this.loadShow = false
					if (e) {
						this.data_product_array = res.objects
					} else {
						this.data_product_array = this.data_product_array.concat(res.objects)
					}
					if (res.objects.length < 10) {
						this.finished = true;
					}
				})
			}
		}
	}
</script>

<style>
	.ticketTop {
		width: 100%;
		background-color: #fff;
		padding: 20px 26px;
		box-sizing: border-box;
		position: sticky;
		top: 0;
		z-index: 999;
	}

	.search {
		height: 68px;
		border-radius: 34px;
		background-color: #f2f2f2;
		font-size: 28px;
		display: flex;
		align-items: center;
		width: 100%;
		padding: 0 28px;
		box-sizing: border-box;
	}

	.search img {
		width: 28px;
		height: 28px;
		margin-right: 20px;
	}

	.packageSearch_con__input {
		flex: 1;
		border: 0;
		height: 66px;
		background-color: #f2f2f2;
	}

	.cityList {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}

	.city_left {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		flex-wrap: wrap;
		gap: 14px;
		flex: 1;
		font-size: 30px;
		color: #293243;
		z-index: 33;
	}

	.city_left span {
		width: 100%;
		text-align: center;
		margin-top: 20px;
	}

	.city_active {
		position: relative;
		font-weight: bold;
		font-size: 34px;
	}

	.city_active::after {
		content: "";
		position: absolute;
		bottom: -4px;
		left: 50%;
		z-index: -1;
		transform: translateX(-50%);
		width: 71px;
		height: 15px;
		background: linear-gradient(90deg, #FFC98B 0%, #FF7303 100%);
		border-radius: 10px;
	}

	.city_right {
		width: 31px;
		height: 31px;
		background: linear-gradient(180deg, #FF7102 0%, #FFA843 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 24px;
	}

	.unfolds {
		margin-top: 10px !important;
	}

	.arrow-up {
		height: 12px;
		width: 12px;
		border-width: 0 3px 3px 0;
		border-style: solid;
		color: #ffffff;
		/* 根据这个来控制箭头方向 */
		transform: rotate(45deg);
		margin-bottom: 8px;
	}

	.arrow-down {
		height: 12px;
		width: 12px;
		border-width: 0 3px 3px 0;
		border-style: solid;
		color: #ffffff;
		/* 根据这个来控制箭头方向 */
		transform: rotate(-135deg);
		margin-top: 8px;
	}

	.customSwim_list {
		width: 100%;
		padding: 20px 24px;
		box-sizing: border-box;
		background-color: #f5f5f5;
	}

	.customSwim_list-item {
		border-radius: 12px;
		display: flex;
		align-items: center;
		background-color: #ffffff;
		margin-bottom: 20px;
		padding: 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.customSwim_list-iteml {
		width: 300px;
		height: 300px;
		position: relative;
	}

	.customSwim_list-iteml img {
		width: 300px;
		height: 300px;
		border-radius: 10px;
	}

	.customSwim_list-iteml label {
		width: 300px;
		height: 300px;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, .1);
		border-radius: 10px;
		padding: 8px;
		box-sizing: border-box;
		display: flex;
	}

	.customSwim_list-iteml p {
		background-color: rgba(0, 0, 0, 0.3);
		border-radius: 20px;
		height: 40px;
		color: #FFFFFF;
		display: flex;
		align-items: center;
		width: 118px;
		justify-content: center;
	}

	.customSwim_list-iteml font {
		/* transform: scale(.8); */
		font-size: 24px;
	}

	.customSwim_list-itemr {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 300px;
		padding-left: 16px;
		box-sizing: border-box;
		position: relative;
	}

	.customSwim_list-itemr h2 {
		font-size: 30px;
		color: #36393E;
		line-height: 46rpx;
		display: -webkit-box;
		overflow: hidden;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.customSwim_list-itemr-tag {
		display: flex;
		flex-direction: column;
		width: fit-content;
	}

	.customSwim_list-itemr-tag p {
		min-width: 170px;
		height: 40px;
		border: 1px solid rgba(61, 140, 247, .24);
		font-size: 22px;
		color: #1B78F6;
		line-height: 40px;
		text-align: center;
		padding: 0 14px;
		box-sizing: border-box;
		margin-top: 14px;
		border-radius: 6px;
	}

	.customSwim_list-itemr-price {
		color: #E54E0C;
		font-size: 26px;
		position: absolute;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: baseline;
	}

	.customSwim_list-itemr-price p {
		font-size: 22px;
		padding-left: 2px;
	}

	.customSwim_list-itemr-price font {
		font-size: 36px;
		font-weight: bold;
	}

	.customSwim_list-itemr-prices {
		margin-top: auto;
		margin-left: auto;
		font-size: 20px;
		color: #ccc;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.customSwim_tablist {
		background-color: #f5f5f5;
	}

	.tablist {
		width: 100%;
		padding: 20px 24px 0 24px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 17px;
		z-index: 2;
		position: relative;
	}

	.tablist label {
		flex: 1;
		height: 54px;
		background: #FFFFFF;
		border-radius: 10px;
		font-size: 28px;
		color: #666666;
		text-align: center;
		line-height: 54px;
		border-radius: 24px;
	}

	.activeTab {
		background-color: #4D94F5 !important;
		color: #ffffff !important;
	}
</style>